<template>
    <div class="w-full sm:w-590px">
        <div class="text-25 text-tc-blue-3 ml-24 pl-1 main-bold">
            {{ userData.firstName }} {{ userData.lastName }}
        </div>
        <div class="relative border rounded-20 shadow-cart-1 mb-5 background-user">
            <div class="absolute w-75px p-6px circle-user-image overflow-hidden">
                <template v-if="userData.profileImageUrl">
                    <img class="w-75px rounded-full" :src="userData.profileImageUrl" />
                </template>
                <template v-else>
                    <img src="@/assets/icon/profile-icon.png" />
                </template>
            </div>
            <div class="absolute top-0 px-8 w-full">
                <div class="flex">
                    <div class="ml-20 flex-grow w-full">
                        <div class="text-white">
                            <span class="text-18 pr-2">{{lbl.profile.tips_coins}}</span>
                            <span class="text-26 flex-1">
                                {{ FilterNumberFormat(userData.point) }}
                            </span>
                            <img class="w-5 icon-coin inline-block" src="@/assets/icon/coin-point.png">
                        </div>
                        <div class="text-tc-gray-4 text-16">{{ statusCoint }}</div>
                    </div>
                     <div class="flex justify-end">
                        <div class="w-20 mt-3">
                            <router-link to="/profile/edit">
                                <OutlineWhiteBtn>{{lbl.profile.edit}}</OutlineWhiteBtn>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-4 mt-2">
                    <div>
                        <LabelText
                            :label="lbl.profile.contact_number"
                            :content="userData.contact_number"
                            class-content="text-white text-20"
                            class-label="text-white text-16"
                        />
                    </div>
                    <div>
                        <LabelText
                            :label="lbl.profile.email"
                            :content="userData.email"
                            class-content="text-white text-20"
                            class-label="text-white text-16"
                        />
                    </div>
                </div>
                <div class="flex justify-center mt-2 sm:mt-60px">
                    <div class="w-32 mr-3 sm:w-40">
                        <OutlineBlueBtn @click="clickHistory()">
                            <div class="text-22">{{lbl.profile.coin_history}}</div>
                        </OutlineBlueBtn>
                    </div>
                    <div class="w-32 ml-3 sm:w-40">
                        <OutlineBlueBtn @click="clickTrasferPoints()">
                            <div class="text-22">{{lbl.profile.coin_tranfer}}</div>
                        </OutlineBlueBtn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LabelText from "@/components/Input/simple/LabelText.vue";
import OutlineWhiteBtn from "@/components/Button/OutlineWhiteBtn.vue";
import OutlineBlueBtn from "@/components/Button/OutlineBlueBtn.vue";
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: 'UserInfo',
    mixins: [LocaleMixin],
    components:{
        LabelText,
        OutlineWhiteBtn,
        OutlineBlueBtn
    },
    props:{
        userData: Object
    },
    data: function() {
        return {
            statusCoint: '',
        };
    },
    created: function () {
        this.statusCoint = this.lbl.profile.point_not_expire;
    },
    methods: {
        clickHistory: function() {
            this.$router.push('/history/redeem');
        },
        clickTrasferPoints: function(){
            this.$emit('clickTransfer')
        }
    }
};
</script>

<style lang="scss" scoped>
.circle-user-image{
    border-top: 1px solid #1c3e95;
    border-bottom: 1px solid #fff;
    border-radius: 50%;
    left: 15px;
    top: -2.5rem;
}
.icon-coin{
    margin-top: -4px;
}
.background-user{
    background-image: url("../../../assets/bg/bg-user.png");
    background-color: #1b44a1;
    min-height: 187px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
</style>
